export const fieldRebateAccountID = "rebateAccountID";
export const CLIENT_ANF_TABLE_FILTER_REPORT_START_DATE = "2024-01-01T00:00:00";
export const COLUMN_DATE_FORMAT = "DD MMM YYYY";
